<template>
  <div class="">
    <!-- Show parent gallery first if it has media -->
    <div v-if="hasParentMedia" class="">
      <component 
        :is="getDisplayTypeComponent(gallery)" 
        :gallery="gallery"
        @openGallery="$emit('openGallery', $event)"
      />
    </div>

    <!-- Show sub-galleries -->
    <div v-for="(subGallery, index) in gallery.sub_gallery" :key="index" class="list-gallery">
      <component 
        :is="getDisplayTypeComponent(subGallery)" 
        :gallery="subGallery" 
        @openGallery="$emit('openGallery', $event)"
      />
    </div>
  </div>
</template>

<script>
import { GalleryDisplayType } from '../constants/galleryDisplayType'
import HorizontalGallery from '../displayType/Horizontal'
import VerticalGallery from '../displayType/Vertical'
import CompactThumbGallery from '../displayType/CompactThumb'
import CompactHorizontalGallery from '../displayType/CompactHorizontal'
import ReelGallery from '../displayType/Reel'
import ContainerGallery from '../displayType/Container'

export default {
  name: 'MediaDisplayerList',

  components: {
    HorizontalGallery,
    VerticalGallery,
    CompactThumbGallery,
    CompactHorizontalGallery,
    ReelGallery,
    ContainerGallery
  },

  props: {
    gallery: {
      type: Object,
      required: true
    }
  },

  computed: {
    hasParentMedia() {
      return this.gallery && this.gallery.tabs && this.gallery.tabs.some(tab => tab.count > 0)
    }
  },

  methods: {
    getDisplayTypeComponent(subGallery) {
      if (!subGallery || !subGallery.display_type) {
        return 'VerticalGallery'
      }

      switch (subGallery.display_type) {
        case GalleryDisplayType.HORIZONTAL.value:
          return 'HorizontalGallery'
        case GalleryDisplayType.VERTICAL.value:
          return 'VerticalGallery'
        case GalleryDisplayType.COMPACT_THUMB.value:
          return 'CompactThumbGallery'
        case GalleryDisplayType.COMPACT_HORIZONTAL.value:
          return 'CompactHorizontalGallery'
        case GalleryDisplayType.REEL.value:
          return 'ReelGallery'
        case GalleryDisplayType.CONTAINER.value:
          return 'ContainerGallery'
        default:
          return 'VerticalGallery'
      }
    }
  }
}
</script>